/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import { MessageData } from 'cio/services/subscription-center';

interface MessageRowArgs {
  readOnly: boolean;
  messageIndex: number;
  message: MessageData;
  selectedMessages: MessageData[];
  toggleMessageSelection: (message: MessageData, index: number, checked: boolean) => unknown;
  subscriptionTopics: SubscriptionTopicModel[];
  state: string;
}

export default class MessageRow extends Component<MessageRowArgs> {
  @service store!: DS.Store;

  get subscriptionTopicName() {
    let messageSubscriptionTopicId = this.args.message.subscriptionTopicId.toString();
    return this.args.subscriptionTopics.find((topic) => messageSubscriptionTopicId === topic.id)?.name;
  }

  get checked() {
    return this.args.selectedMessages.some((message) => message.uniqueID === this.args.message.uniqueID);
  }

  get messageModel() {
    if (this.args.message.type === 'api_triggered_broadcast') {
      return this.store.peekRecord('campaign', this.args.message.id);
    }
    return this.store.peekRecord(this.args.message.type, this.args.message.id);
  }

  get messageRouteName() {
    if (this.args.message.type === 'newsletter') {
      return `broadcasts.newsletter.setup.recipients`;
    }

    return `${
      this.messageModel.isApiTriggered === true
        ? 'broadcasts.broadcast.overview.settings'
        : 'campaigns.campaign.overview.settings'
    }`;
  }
}
